//npm i --save-dev @types/rodal does not work
import { useEffect } from 'react'
import Rodal from 'rodal'
import 'rodal/lib/rodal.css'
import { directionStyles, Container } from './LumiarDrawerStyles'
import { ILumiarDrawer } from './LumiarDrawerTypes'

const LumiarDrawer = ({
  visibility,
  children,
  onChange,
  side = 'right',
  scrollable = true,
  modalRef,
  closeOnMaskClick = true,
  closeOnEsc = false,
}: ILumiarDrawer) => {
  const modalDirection = side === 'right' ? 'slideRight' : 'slideLeft'

  const scroll = scrollable ? 'scroll' : 'hidden'
  const styles = directionStyles[side]

  // Trava o scroll da página por trás enquanto o drawer está aberto (Rodal não faz
  // isso, gerando "scroll duplo"). O cleanup SEMPRE restaura o valor anterior — ao
  // fechar ou desmontar — para não deixar a página travada.
  useEffect(() => {
    if (!visibility) return undefined
    const { style } = document.documentElement
    const previousOverflow = style.overflow
    style.overflow = 'hidden'
    return () => {
      style.overflow = previousOverflow
    }
  }, [visibility])

  return (
    <Container>
      <Rodal
        visible={visibility}
        onClose={() => {
          onChange(false)
          document.body.style.overflow = 'scroll'
        }}
        showMask
        closeMaskOnClick={closeOnMaskClick}
        closeOnEsc={closeOnEsc}
        animation={modalDirection}
        customStyles={{ ...styles, overflow: scroll }}
        ref={modalRef}
      >
        {children}
      </Rodal>
    </Container>
  )
}
export default LumiarDrawer
